import React, { useEffect, useState } from "react";
import { getSizesByOrderId } from "../services/api";
import styles from "../styles/estilos/TablaTallesDinamica.module.css";
import measureStyles from "../styles/MeasureLittle.module.css";

const TablaTallesDinamica = ({ order_id, molderia, moldingId }) => {
  const [tallesPorItem, setTallesPorItem] = useState({});
  // Tres estados distintos, no uno: «cargando», «no hay tabla» y «falló» se veían todos igual
  // —un «Cargando tabla de talles…» que no terminaba nunca— porque el único indicio era que el
  // objeto estuviera vacío. El cliente se quedaba mirando un cartel que nunca iba a cambiar.
  const [estado, setEstado] = useState("cargando");

  useEffect(() => {
    let vigente = true;
    const fetchSizes = async () => {
      setEstado("cargando");
      try {
        // Va SIEMPRE la moldería: si el pedido todavía no tiene sus talles cargados, con ella la
        // API responde con el catálogo. Sin mandarla devolvía {} y la tabla quedaba en blanco
        // para siempre. Con el id si el que abre lo tiene, y si no por NOMBRE —desde «Cargar
        // talle» y «Editar talle» es lo único que hay— para que funcione desde todos lados.
        const data = await getSizesByOrderId(order_id, moldingId, undefined, molderia);
        if (!vigente) return;
        const tallesFiltrados = data?.[molderia] || [];

        const tallesNormalizados = tallesFiltrados.map((talle) => ({
          ...talle,
          item: talle.OrderItemCategory?.name ?? talle.item ?? `Categoría ${talle.order_item_category_id}`,
        }));

        const agrupacionPorItem = tallesNormalizados.reduce((acc, talle) => {
          if (!acc[talle.item]) {
            acc[talle.item] = [];
          }
          acc[talle.item].push(talle);
          return acc;
        }, {});

        setTallesPorItem(agrupacionPorItem);
        setEstado(Object.keys(agrupacionPorItem).length ? "ok" : "vacio");
      } catch (error) {
        console.error("Error al obtener talles dinámicos:", error);
        if (vigente) setEstado("error");
      }
    };

    fetchSizes();

    return () => {
      vigente = false;
    };
  }, [order_id, molderia, moldingId]);

  if (estado === "cargando") {
    return <p className={measureStyles.tableLoading}>Cargando tabla de talles...</p>;
  }

  if (estado === "error") {
    return (
      <p className={measureStyles.tableLoading}>
        No pudimos traer la tabla de talles. Probá de nuevo en un rato.
      </p>
    );
  }

  if (estado === "vacio") {
    return (
      <p className={measureStyles.tableLoading}>
        Todavía no hay medidas cargadas para {molderia}. Escribinos y te ayudamos a elegir el talle.
      </p>
    );
  }

  return (
    <div className={styles.wrapper}>
      {Object.entries(tallesPorItem).map(([item, talles]) => (
        <div key={item} className={styles.itemGroup}>
          <h3 className={styles.itemTitle}>{item}</h3>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={`${styles.th} ${styles.headerCol}`}>Talle</th>
                {talles.map((talle, index) => (
                  <th
                    key={talle.id + "-head"}
                    className={`${styles.th} ${styles.noTopBorder} ${
                      index === 0 ? styles.firstTh : ""
                    } ${index === talles.length - 1 ? styles.lastTh : ""}`}
                  >
                    {talle.code}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={`${styles.td} ${styles.labelCol}`}>Ancho</td>
                {talles.map((talle, index) => (
                  <td
                    key={`ancho-${talle.id}`}
                    className={`${styles.td} ${
                      index === 0 ? styles.firstTh : ""
                    } ${index === talles.length - 1 ? styles.lastTh : ""} ${styles.firstRow}`}
                  >
                    {talle.min_width} - {talle.max_width} cm
                  </td>
                ))}
              </tr>
              <tr>
                <td className={`${styles.td} ${styles.labelCol}`}>Alto</td>
                {talles.map((talle, index) => (
                  <td
                    key={`alto-${talle.id}`}
                    className={`${styles.td} ${
                      index === 0 ? styles.firstTh : ""
                    } ${index === talles.length - 1 ? styles.lastTh : ""} ${styles.lastRow}`}
                  >
                    {talle.min_height} - {talle.max_height} cm
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default TablaTallesDinamica;
